import React from 'react';
import { graphql, compose } from 'react-apollo';
import BaseWidget from '../../../../widgets/baseWidget';
import { getMembersStatistics } from './queries/queries';
import MembersWidget from '../../common/widgets/members';
import DataProcessor from '../../common/dataProcessors/membersDataProcessor';
import { ErrorBoundary } from "../../../../errorBoundary/errorBoundary";

class Members extends BaseWidget {
  get statisticsData() {
    return this.props.data.statistics.churchManager.church.allTime.members;
  }

  get dataProcessor() {
    return new DataProcessor(this.apiData);
  }

  render() {
    return <MembersWidget data={this.dataProcessor.data}
                          loading={this.props.data.loading}
                          comment={this.comment} />;
  }
}

export default compose(
  graphql(getMembersStatistics,
    {
      options: {
        fetchPolicy: 'network-only',
        notifyOnNetworkStatusChange: true //e.vasilevsky TODO: make it default after updating react-apollo to the latest version
      }
    }),
  ErrorBoundary
)(Members);



// WEBPACK FOOTER //
// ./src/components/pages/statistics/church/allTime/members.js